import { render } from "./index.vue?vue&type=template&id=1473e41f"
const script = {}

import exportComponent from "/var/www/upgrade-junction/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__